import React from 'react'
import styled from 'styled-components';
import {InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import ProgressBar from './ProgressBar';

function Skills() {
    return (
        <SkillsStyled>
            
                <Title title={'My Skills'} span={'my skills'} />
                <InnerLayout>
                    <div className="skills">
                        <ProgressBar 
                            title={'Familiarity with Java and MERN Stack'}
                            width={'100%'}
                            text={''}
                        />
                        <ProgressBar 
                            title={'Machine learning, Deep learning and Python'}
                            width={'100%'}
                            text={''}
                        />
                        <ProgressBar 
                            title={'Data Structures and Algorithms '}
                            width={'100%'}
                            text={''}
                        />
                        <ProgressBar 
                            title={'Working familiarity and practical experience with llm finetuning ,prompt engineering with langchain and opencv '}
                            width={'100%'}
                            text={''}
                        />
                        <ProgressBar 
                            title={'Hands on experience with python backend frameworks like Django, fastapi and flask with AWS services'}
                            width={'100%'}
                            text={''}
                        />
                        <ProgressBar 
                            title={'Exposure to Devops tools like Docker and Jenkins '}
                            width={'100%'}
                            text={''}
                        />
                        
                    </div>
                </InnerLayout>
        </SkillsStyled>
    )
}

const SkillsStyled = styled.section`
    .skills{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-row-gap: 2rem;
        grid-column-gap: 3rem;
        @media screen and (max-width: 700px){
            grid-template-columns: repeat(1, 1fr);
        }
        overflow-x: auto; /* Enable horizontal scrolling */
    }
`;

export default Skills;
